<template>
  <div>

    <template v-if="products">
      <div class="trproductcontainer">
        <div class="trproductitem" v-for="(item) in products" :key="item.id">

          <item-grid-view :item="item" @click="additemInCart(item)" :ref="`product${item.id}`">

            <!-- SLOT: ACTION BUTTONS -->
            <template slot="action-buttons">
              <div class="flex flex-wrap buttons-wrapper">
                <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                <div
                  class="item-view-secondary-action-btn p-3 flex flex-grow items-center justify-center text-danger cursor-pointer">
                  <span class="text-lg font-semibold ml-2">${{formatPrice((item.price !== 0) ? item.price : (item.size !== null) ? item.size.items[0].price : 0)}}</span>
                </div>
              </div>
            </template>
          </item-grid-view>

        </div>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  props: {
    products: {
      type: Array,
      required: true
    },
    product_id : {
      type: String
    }
  },
  name: 'TabProducts',
  mounted () {
    setTimeout(() => {
      this.checkViewProduct()
    }, 1000)
  },
  data () {
    return {
      productSidebar: false,
      sidebarData: {},
      viewProductId: null
    }
  },
  watch: {
    product_id () {
      this.checkViewProduct()
    }
  },
  components: {
    ItemGridView: () => import('../../products/components/ItemGridView.vue'),
    ItemListView: () => import('../../products/components/ItemListView.vue'),
    AddProductSidebar: () => import('../../products/AddProductSidebar')
  },
  computed: {},
  methods: {

    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    toggleProductSidebar (val = false) {
      this.productSidebar = val

    },
    checkViewProduct () {
      //const productToShow = this.products.find(x => String(x.id) === this.product_id)
      if (this.product_id) {
        this.$refs['product'.concat(this.product_id)][0].$el.click()
      }
    },
    additemInCart (item) {
      //this.$store.dispatch('eCommerce/additemInCart', item)
      if (item.size) {
        const selected_size = item.size.items[0]
        let name = selected_size.name
        if (selected_size.price !== '0') {
          name = name.concat(' - $').concat(selected_size.price)
        }
        item.size.selected_value = {label: name, value: selected_size.id, price: selected_size.price}
      }
      this.sidebarData = item
      //this.sidebarData.section_options = this.getSectionOptionsList()
      //this.sidebarData.size_options = this.getSizeOptionsList()
      //this.sidebarData.modifier_options = this.getModifierOptionsList()
      this.toggleProductSidebar(true)
    }
  }
}
</script>

<style lang="scss">
  .items-grid-view {
    padding: 20px 0 !important;

    .col-padding {
      padding-left: 0;
      padding-right:10px;
    }

  }

  .mobile .col-padding {
    padding: 0 ;
  }

</style>
